<ifb-card>
  <mat-card appearance="raised" class="card">
    <mat-card-header class="card-header mat-elevation-z4">
      <mat-card-title class="card-header__title-container">
        <div class="avatar">
          <mat-icon class="icon">account_balance</mat-icon>
        </div>
        <h2 class="card-header__heading">{{ accountsGroupedByInstitution?.institution }}</h2>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="mat-card-content-lg no-bottom-padding">
      <mat-list>
        <mat-list-item *ngFor="let account of accountsGroupedByInstitution.accounts; index as i">
          <span class="index" matListItemIcon>{{ i + 1 }}</span>
          <span matListItemTitle>
            <a class="default-link" (click)="bankAccountDetailsLink(account?.id)">
              {{ account?.routingNumber }} - {{ account?.accountNumber }}
            </a>
          </span>
          <span matListItemLine *ngIf="account?.balance">{{ account?.balance | currency: '$' }}</span>
          <span matListItemLine *ngIf="account?.lastUpdatedDate">{{ account?.lastUpdatedDate | date }}</span>
        </mat-list-item>
      </mat-list>
    </mat-card-content>
  </mat-card>
</ifb-card>
